var render = function render(_c,_vm){return _c('div',{staticClass:"rounded d-inline-block pl-3 pr-3 ma-1 inverted text-center"},[_c('nuxt-link',{staticClass:"text-decoration-none font-weight-bold",attrs:{"data-test-id":"KeywordsLink","to":`/engage/${_vm.partner}/search-dashboard?keywords=${_vm.props.keyword}`}},[_vm._v(_vm._s(_vm.props.keyword))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }